import { IStoreApiItem, StoreApiItem } from '@/common/interfaces/store-api-item.interface'
import { IStoreApiList, StoreApiList } from '@/common/interfaces/store-api-list.interface'

import { IStripeTerminal } from 'src/features/stripe-terminals/interfaces/stripe-terminal.interface'

export interface IStripeTerminalsState {
  stripeTerminals: IStoreApiList<IStripeTerminal[]>
  stripeTerminal: IStoreApiItem<IStripeTerminal>
  stripeTerminalUpdate: IStoreApiItem<IStripeTerminal>
  stripeTerminalDelete: IStoreApiItem<IStripeTerminal>
  stripeTerminalCreate: IStoreApiItem<IStripeTerminal>
  stripeTerminalMediaUpload: IStoreApiItem<any>
  stripeTerminalMediaDelete: IStoreApiItem<any>
}

export class StripeTerminalsState implements IStripeTerminalsState {
  stripeTerminals: IStoreApiList<IStripeTerminal[]> = new StoreApiList()
  stripeTerminal: IStoreApiItem<IStripeTerminal> = new StoreApiItem()
  stripeTerminalUpdate: IStoreApiItem<IStripeTerminal> = new StoreApiItem()
  stripeTerminalDelete: IStoreApiItem<IStripeTerminal> = new StoreApiItem()
  stripeTerminalCreate: IStoreApiItem<IStripeTerminal> = new StoreApiItem()
  stripeTerminalMediaUpload: IStoreApiItem<any> = new StoreApiItem()
  stripeTerminalMediaDelete: IStoreApiItem<any> = new StoreApiItem()
}
